import React from "react";

import faceBook from "../../assets/images/integration/facebook.svg";
import instaGram from "../../assets/images/integration/instagram.png";
import linkeDin from "../../assets/images/integration/Linkedin.svg";
import googleAdwords from "../../assets/images/integration/google_adwords.png";
import forms from "../../assets/images/integration/forms.svg";
import webtrials from "../../assets/images/integration/Webtrials.svg";
import makeMyTrip from "../../assets/images/integration/makeMyTrip.svg";
import bookingCom from "../../assets/images/integration/Booking-com.png";
import tripAdvisor from "../../assets/images/integration/tripadvisor.png";
import airBnB from "../../assets/images/integration/airbnb.svg";
import triVago from "../../assets/images/integration/trivago.png";
import agoDa from "../../assets/images/integration/agoda.svg";
import gmail from "../../assets/images/integration/gmail.png";
import outlook from "../../assets/images/integration/outlook.png";
import mailChimp from "../../assets/images/integration/mailchimp.svg";

const categories = [
  {
    title: "Social Media Integration",
    subtitle: "Engage Your Audience Where They Are",
    items: [
      {
        logo: faceBook,
        name: "Facebook",
        desc: "Launch targeted ads, schedule posts, and analyze engagement all from one dashboard.",
      },
      {
        logo: instaGram,
        name: "Instagram",
        desc: "Share impactful visuals, run interactive campaigns, and track performance to boost brand presence.",
      },
      {
        logo: linkeDin,
        name: "LinkedIn",
        desc: "Build professional connections, manage sponsored content, and nurture leads with tailored outreach.",
      },
    ],
  },
  {
    title: "Google Integration",
    subtitle: "Maximize Your Online Visibility",
    items: [
      {
        logo: googleAdwords,
        name: "Google AdWords",
        desc: "Launch targeted ads, manage budgets, and track ROI with real-time insights.",
      },
      {
        logo: forms,
        name: "Forms",
        desc: "Collect leads and customer information efficiently, feeding them directly into your CRM.",
      },
      {
        logo: webtrials,
        name: "Webtrials",
        desc: "Integrate your trial campaigns with ease, nurturing prospects from initial interest to conversion.",
      },
    ],
  },
  {
    title: "OTA Platform Integration",
    subtitle: "For the Travel and Hospitality Industry",
    items: [
      {
        logo: makeMyTrip,
        name: "MakeMyTrip",
        desc: "Capture leads and manage bookings directly in your CRM for better customer follow-up.",
      },
      {
        logo: bookingCom,
        name: "Booking.com",
        desc: "Sync reservations and guest information to personalize service and enhance customer experience.",
      },
      {
        logo: tripAdvisor,
        name: "TripAdvisor",
        desc: "Monitor reviews, manage inquiries, and track potential leads from the world’s most trusted travel platform.",
      },
      {
        logo: airBnB,
        name: "Airbnb",
        desc: "Integrate guest data and streamline communication to provide a smooth guest experience.",
      },
      {
        logo: triVago,
        name: "Trivago",
        desc: "Optimize pricing strategies and track competition for smarter marketing decisions.",
      },
      {
        logo: agoDa,
        name: "Agoda",
        desc: "Sync your Agoda listings and bookings for more streamlined lead management and customer outreach.",
      },
    ],
  },
  {
    title: "Email Marketing Integration",
    subtitle: "Effortless Outreach with Maximum Impact",
    items: [
      {
        logo: gmail,
        name: "Gmail",
        desc: "Sync your Gmail account for seamless email creation, tracking, and automated responses directly from your CRM.",
      },
      {
        logo: outlook,
        name: "Outlook",
        desc: "Integrate with Outlook for a unified experience, sending and managing emails without leaving the platform.",
      },
      {
        logo: mailChimp,
        name: "Mailchimp",
        desc: "Automate email campaigns, segment audiences, and analyze performance—all within your dashboard.",
      },
    ],
  },
];

const IntegrationsList = () => {
  return (
    <section className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100" id="integrations-list">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {categories.map((cat, catIdx) => (
          <div key={catIdx} className={catIdx > 0 ? "tw-mt-24 lg:tw-mt-32" : ""}>
            
            {/* Category Header */}
            <div className="tw-text-center tw-mb-12 lg:tw-mb-16">
              <h2 className="tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-3">
                {cat.title}
              </h2>
              <p className="tw-text-sm sm:tw-text-base tw-text-slate-500 tw-font-medium">
                {cat.subtitle}
              </p>
            </div>

            {/* Integration Cards Grid */}
            <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-8 tw-max-w-5xl tw-mx-auto">
              {cat.items.map((item, itemIdx) => (
                <div
                  key={itemIdx}
                  className="tw-group tw-relative tw-overflow-hidden tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-3xl tw-p-8 tw-shadow-sm hover:tw-shadow-xl hover:tw-scale-[1.02] tw-transition-all tw-duration-300 tw-text-left tw-flex tw-flex-col"
                >
                  {/* Logo Container (No backgrounds or borders around the icon) */}
                  <div className="tw-h-12 tw-flex tw-items-center tw-mb-6">
                    <img
                      src={item.logo}
                      alt={item.name}
                      className="tw-h-8 sm:tw-h-9 tw-w-auto tw-object-contain"
                      loading="lazy"
                    />
                  </div>

                  {/* Title */}
                  <h3 className="tw-text-base tw-font-bold tw-text-slate-800 tw-mb-2">
                    {item.name}
                  </h3>

                  {/* Description */}
                  <p className="tw-text-sm tw-text-slate-500 tw-leading-relaxed tw-m-0">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>

          </div>
        ))}

      </div>
    </section>
  );
};

export default IntegrationsList;
